const ProgressValue = {};
export default ProgressValue;

ProgressValue.STARTED = "started";
ProgressValue.COMPLETED = "completed";
ProgressValue.BLUR = "blur";
ProgressValue.FOCUS = "focus";
ProgressValue.RESUME = "resume";